/* eslint-disable default-case */
import produce from 'immer';

import {
  types,
  GetKioskTicketTemplatesSuccess,
  GetKioskTicketTemplatesError,
  GetKioskTicketTemplatesPending,
  UpdateKioskTicketTemplatePayload,
  UpdateKioskTicketTemplatePending,
  UpdateKioskTicketTemplateSuccess,
  UpdateKioskTicketTemplateError,
  KioskTicketTemplatesActionTypes,
  KioskTicketTemplatesState,
  KioskTicketTemplate,
  CreateKioskTicketTemplatePayload,
  DeleteKioskTicketTemplatePending,
  CreateKioskTicketTemplatePending,
  DeleteKioskTicketTemplateError,
  CreateKioskTicketTemplateError
} from './types';

// Actions
export const actions = {
  getKioskTicketTemplates: (payload: { kioskId: string }): KioskTicketTemplatesActionTypes => ({
    type: types.GET_KIOSK_TICKET_TEMPLATES.REQUEST,
    payload
  }),
  resetKioskTicketTemplates: () => ({ type: types.RESET_KIOSK_TICKET_TEMPLATES }),
  updateKioskTicketTemplate: (payload: UpdateKioskTicketTemplatePayload) => ({
    type: types.UPDATE_KIOSK_TICKET_TEMPLATE.REQUEST,
    payload
  }),
  resetError: () => ({ type: types.RESET_ERROR }),
  resetAction: () => ({ type: types.RESET_ACTION }),
  createKioskTicketTemplate: (payload: CreateKioskTicketTemplatePayload): KioskTicketTemplatesActionTypes => ({
    type: types.CREATE_KIOSK_TICKET_TEMPLATE.REQUEST,
    payload
  }),
  deleteKioskTicketTemplate: (payload: { id: string; kioskId: string }): KioskTicketTemplatesActionTypes => ({
    type: types.DELETE_KIOSK_TICKET_TEMPLATE.REQUEST,
    payload
  })
};

// Initial State
export const initialState: KioskTicketTemplatesState = {
  kioskTicketTemplates: [],
  action: {
    success: false,
    pending: false,
    error: null
  }
};

// Reducer
export const reducer = (
  state: KioskTicketTemplatesState = initialState,
  action: KioskTicketTemplatesActionTypes
): KioskTicketTemplatesState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case types.GET_KIOSK_TICKET_TEMPLATES.SUCCESS:
        draft.kioskTicketTemplates = (action as GetKioskTicketTemplatesSuccess).payload;
        break;
      case types.UPDATE_KIOSK_TICKET_TEMPLATE.SUCCESS:
        const payload = (action as UpdateKioskTicketTemplateSuccess).payload;
        draft.action.success = true;
        if (draft.kioskTicketTemplates.length) {
          const ticketTemplateIndex = draft.kioskTicketTemplates.findIndex(
            (kh) => kh.id === (payload as KioskTicketTemplate).id
          );
          if (ticketTemplateIndex > -1) {
            Object.assign(draft.kioskTicketTemplates[ticketTemplateIndex], payload);
          }
        }
        break;
      case types.DELETE_KIOSK_TICKET_TEMPLATE.SUCCESS:
      case types.CREATE_KIOSK_TICKET_TEMPLATE.SUCCESS:
        draft.action.success = true;
        break;
      case types.GET_KIOSK_TICKET_TEMPLATES.PENDING:
      case types.UPDATE_KIOSK_TICKET_TEMPLATE.PENDING:
      case types.CREATE_KIOSK_TICKET_TEMPLATE.PENDING:
      case types.DELETE_KIOSK_TICKET_TEMPLATE.PENDING:
        draft.action.pending = (
          action as
            | GetKioskTicketTemplatesPending
            | UpdateKioskTicketTemplatePending
            | CreateKioskTicketTemplatePending
            | DeleteKioskTicketTemplatePending
        ).payload;
        break;
      case types.GET_KIOSK_TICKET_TEMPLATES.ERROR:
      case types.UPDATE_KIOSK_TICKET_TEMPLATE.ERROR:
      case types.CREATE_KIOSK_TICKET_TEMPLATE.ERROR:
      case types.DELETE_KIOSK_TICKET_TEMPLATE.ERROR:
        draft.action.error = (
          action as
            | GetKioskTicketTemplatesError
            | UpdateKioskTicketTemplateError
            | CreateKioskTicketTemplateError
            | DeleteKioskTicketTemplateError
        ).payload;
        break;
      case types.RESET_KIOSK_TICKET_TEMPLATES:
        draft.kioskTicketTemplates = initialState.kioskTicketTemplates;
        break;
      case types.RESET_ERROR:
        draft.action.error = initialState.action.error;
        break;
      case types.RESET_ACTION:
        draft.action = initialState.action;
        break;
    }
  });
};
